import routes from 'routing/routes'

export const getRouteByPath = path => routes.find(route => path === route.path)
